import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';

const DialogImportReac = ({ open, result, onClose }) => {
    if (!result) return null;
    const { added, errors } = result;
    return (
        <Dialog open={open} maxWidth="xs" fullWidth onClose={onClose}>
            <DialogTitle>Importación completada</DialogTitle>
            <DialogContent dividers>
                {added > 0 && (
                    <DialogContentText style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <CheckCircleIcon style={{ color: '#43a047' }} />
                        {added} artículo{added !== 1 ? 's' : ''} importado{added !== 1 ? 's' : ''} correctamente.
                    </DialogContentText>
                )}
                {errors.length > 0 && (
                    <DialogContentText style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <ErrorIcon style={{ color: '#e53935' }} />
                        {errors.length} error{errors.length !== 1 ? 'es' : ''}: {errors.join(', ')}
                    </DialogContentText>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" variant="contained" disableElevation>Cerrar</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DialogImportReac;
